import React, { useState, useRef } from "react";
import Calendar from "../Calendar/Calendar";
import { format, parse } from "date-fns";
import useOnClickOutside from "../../hooks/useOnClickOutside";
import { Input } from "../Modals/DocumentModal/DocumentModal.styles";
import TitleTooltip from "../TitleTooltip/TitleTooltip";

interface DatePickerInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  title?: string;
}

const DatePickerInput: React.FC<DatePickerInputProps> = ({
  value,
  onChange,
  placeholder,
  title,
}) => {
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside(containerRef, () => setIsCalendarOpen(false));

  // Обработчик изменения даты через календарь
  const handleDateChange = (dates: [Date | null, Date | null]) => {
    const [start] = dates;
    const formattedDate = start ? format(start, "dd.MM.yyyy") : "";
    onChange(formattedDate);
    setIsCalendarOpen(false);
  };

  // Обработчик ввода вручную
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  // При потере фокуса пытаемся разобрать и отформатировать введённую дату
  const handleInputBlur = () => {
    if (value) {
      const parsedDate = parse(value, "dd.MM.yyyy", new Date());
      if (!isNaN(parsedDate.getTime())) {
        onChange(format(parsedDate, "dd.MM.yyyy"));
      }
      // Если дата некорректна, можно оставить значение как есть или очистить его.
    }
  };

  return (
    <div ref={containerRef} style={{ position: "relative", width: "100%" }}>
      <TitleTooltip text={title || ""}>
      <Input
        value={value}
        placeholder={placeholder}
        onChange={handleInputChange}
        onFocus={() => setIsCalendarOpen(true)}
        onBlur={handleInputBlur}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleInputBlur();
            setIsCalendarOpen(false);
          }
        }}
      />
      </TitleTooltip>
      {isCalendarOpen && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            zIndex: 1000,
            width: "190px", // установите нужную ширину
            overflow: "hidden", // скрываем содержимое, выходящее за границы
          }}
        >
          <Calendar
            onDateChange={handleDateChange}
            startDate={value ? new Date(value) : undefined}
            isRange={false}
          />
        </div>
      )}
    </div>
  );
};

export default DatePickerInput;
